<!--
 * @Description: 产品类型销量统计 - 饼图（带俪丰/联农切换）
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
-->
<template>
  <div class="pie-chart">
    <div class="header">
      <div class="title">
        <img src="@/img/datav-tc/title_icon.png" alt="" />
        <span>产品类型销量统计</span>
      </div>
      <div class="tab">
        <div :class="['tab-item', { active: type == 'lifeng' }]" @click="typeChange('lifeng')">
          俪丰
        </div>
        <div :class="['tab-item', { active: type == 'liannong' }]" @click="typeChange('liannong')">
          联农
        </div>
      </div>
    </div>
    <div id="SaleTypePieChart" style="width:100%;height:calc(100% - 70px)"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getSaleTypePie, getGroupStoreList } from '@/api/dashboard-tc'
let myChart

export default {
  data() {
    return {
      type: 'lifeng',
      colorMap: [
        ['#FF006E', '#8338EC'],
        ['#3A86FF', '#00F5FF'],
        ['#FFBE0B', '#FB5607'],
        ['#06FFA5', '#00C9A7'],
        ['#FF4081', '#F50057'],
        ['#00C0FE', '#126DFF'],
        ['#A855F7', '#6366F1'],
        ['#F59E0B', '#EF4444'],
      ],
      data: [],
      appidMap: {},
      timer: null,
    }
  },
  mounted() {
    myChart = echarts.init(document.getElementById('SaleTypePieChart'))
    myChart.resize()
    window.addEventListener('resize', () => {
      myChart.resize()
    })
    this.initAppid()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async initAppid() {
      try {
        const res = await getGroupStoreList()
        if (res.code === 0 && res.data) {
          res.data.forEach(item => {
            if (item.storeName.includes('俪丰')) {
              this.appidMap.lifeng = item.appid
            } else if (item.storeName.includes('联农')) {
              this.appidMap.liannong = item.appid
            }
          })
          this.fetchData()
          this.timer = setInterval(() => {
            this.fetchData()
          }, process.env.VUE_APP_LTIME_TC)
        }
      } catch (error) {
        console.error('获取集团列表失败:', error)
      }
    },
    async fetchData() {
      try {
        const appid = this.type === 'lifeng' ? this.appidMap.lifeng : this.appidMap.liannong
        if (!appid) {
          console.warn('appid未获取到')
          return
        }
        const res = await getSaleTypePie(appid)
        if (res.code === 0) {
          this.data = res.data
          this.initChart()
        }
      } catch (error) {
        console.error('获取销量统计失败:', error)
      }
    },
    initChart() {
      if (!this.data || this.data.length === 0) {
        return
      }
      const currentData = this.data.map((item, index) => {
        if (index < this.colorMap.length) {
          return {
            value: item.value,
            name: item.name,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: this.colorMap[index][0] },
                  { offset: 1, color: this.colorMap[index][1] },
                ],
              },
              shadowBlur: 20,
              shadowColor: this.colorMap[index][0],
              borderRadius: 4,
            },
          }
        }
        return item
      })

      const option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(5, 13, 76, 0.9)',
          borderColor: '#00C0FE',
          borderWidth: 1,
          padding: [12, 16],
          textStyle: {
            fontSize: 14,
            color: '#fff',
          },
          formatter: params => {
            return `<div style="font-size:14px;color:#00C0FE;margin-bottom:4px">${params.name}</div>
                    <div style="font-size:16px;font-weight:bold;color:#fff">销量: <span style="color:${
                      params.color.colorStops ? params.color.colorStops[0].color : params.color
                    }">${params.value}</span></div>
                    <div style="font-size:14px;color:#899DBF">占比: ${params.percent}%</div>`
          },
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 14,
            color: '#899DBF',
          },
        },
        series: [
          // 外发光环
          {
            name: '外发光环',
            type: 'pie',
            radius: ['68%', '70%'],
            center: ['32%', '50%'],
            silent: true,
            itemStyle: {
              color: 'rgba(0, 192, 254, 0.1)',
            },
            label: { show: false },
            data: [{ value: 1 }],
          },
          // 装饰内环
          {
            name: '装饰内环',
            type: 'pie',
            radius: ['28%', '30%'],
            center: ['32%', '50%'],
            silent: true,
            itemStyle: {
              color: 'rgba(0, 192, 254, 0.15)',
            },
            label: { show: false },
            data: [{ value: 1 }],
          },
          // 中心装饰点
          {
            name: '中心点',
            type: 'pie',
            radius: ['0%', '8%'],
            center: ['32%', '50%'],
            silent: true,
            itemStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  { offset: 0, color: '#00C0FE' },
                  { offset: 1, color: 'rgba(0, 192, 254, 0)' },
                ],
              },
              shadowBlur: 15,
              shadowColor: '#00C0FE',
            },
            label: { show: false },
            data: [{ value: 1 }],
          },
          // 玫瑰图主体
          {
            name: '销量占比',
            type: 'pie',
            roseType: 'radius',
            radius: ['32%', '65%'],
            center: ['32%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 8,
              borderColor: 'rgba(5, 13, 76, 0.5)',
              borderWidth: 2,
            },
            label: {
              show: true,
              position: 'outside',
              formatter: params => {
                return `{name|${params.name}}\n{value|${params.value}} {percent|${params.percent}%}`
              },
              rich: {
                name: {
                  fontSize: 12,
                  color: '#899DBF',
                  padding: [0, 0, 4, 0],
                },
                value: {
                  fontSize: 14,
                  fontWeight: 'bold',
                  color: '#fff',
                },
                percent: {
                  fontSize: 12,
                  color: '#00C0FE',
                  padding: [0, 0, 0, 4],
                },
              },
            },
            emphasis: {
              scale: true,
              scaleSize: 8,
              itemStyle: {
                shadowBlur: 30,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 192, 254, 0.5)',
              },
              label: {
                show: true,
                formatter: params => {
                  return `{name|${params.name}}\n{value|${params.value}} {percent|${params.percent}%}`
                },
                rich: {
                  name: {
                    fontSize: 14,
                    color: '#fff',
                    padding: [0, 0, 4, 0],
                  },
                  value: {
                    fontSize: 16,
                    fontWeight: 'bold',
                    color: '#00C0FE',
                  },
                  percent: {
                    fontSize: 14,
                    color: '#00C0FE',
                    padding: [0, 0, 0, 4],
                  },
                },
              },
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 10,
              lineStyle: {
                color: 'rgba(137, 157, 191, 0.3)',
              },
            },
            data: currentData,
          },
        ],
      }
      myChart.setOption(option)
    },
    typeChange(type) {
      this.type = type
      this.fetchData()
    },
  },
}
</script>

<style lang="scss" scoped>
.pie-chart {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 25px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0px;

    .title {
      font-size: 24px;
      color: #ecf8ff;
      display: flex;
      align-items: center;

      img {
        margin-right: 3px;
      }
    }

    .tab {
      display: flex;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 20px;
      border: 1px solid rgba(0, 192, 254, 0.3);
      padding: 3px;
      margin-top: 10px;
      position: relative;
      overflow: hidden;

      .tab-item {
        padding: 0 16px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        transition: all 0.3s ease;
        border-radius: 13px;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(0, 192, 254, 0.2), rgba(18, 109, 255, 0.2));
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        &:hover {
          color: #66ffff;

          &::before {
            opacity: 1;
          }
        }

        &.active {
          background: linear-gradient(90deg, #00c0fe 0%, #126dff 100%);
          color: #fff;
          box-shadow: 0 0 15px rgba(0, 192, 254, 0.5), inset 0 0 10px rgba(255, 255, 255, 0.2);
          font-weight: 600;

          &::before {
            display: none;
          }
        }
      }
    }
  }
}
</style>
